import _ from 'underscore';
import { useContext, useEffect, useState, useMemo } from 'react';

import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { useAccount } from '@bingads-webui/overreact-odata-campaign';
import { McaAccountTier, useM365Enabled } from '@bingads-webui-campaign-react/mca-core';

import { useAccountLevelVariables } from './use-variables';

export const useIsM365PremiumUser = () => {
  const serverContext = useContext(ServerContext);
  const { CurrentAccount } = serverContext || {};
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isM365User, setIsM365User] = useState(false);

  const isM365FeatureEnabled = useM365Enabled();

  const variables = useAccountLevelVariables();
  const config = useMemo(() => ({
    fetch: {
      postponeRead: true,
    },
    refetch: {
      onComplete: (account) => {
        const { McaAccountTier: mcaAccountTier } = account || {};
        const result = !_.isEmpty(mcaAccountTier) &&
          mcaAccountTier.toLowerCase() !== McaAccountTier.None.toLowerCase();

        setIsM365User(result);
      },
      onError: () => {
        // TODO: error handling
      },
    },
  }), []);

  const [, { refetch }] = useAccount(variables, config);

  useEffect(() => {
    if (isM365FeatureEnabled && CurrentAccount && CurrentAccount.Id && !isDataLoaded) {
      setIsDataLoaded(true);
      refetch();
    }
  }, [CurrentAccount, isDataLoaded, isM365FeatureEnabled, refetch]);

  return isM365User;
};
